<template>
  <b-modal :visible="visible" :title="ticket ? `OS ${ticket.numero}` : 'Chamado'"
    modal-class="ast-modal" size="lg" scrollable hide-footer
    :no-close-on-backdrop="busy" :no-close-on-esc="busy" :hide-header-close="busy" @hidden="$emit('close')">
    <div v-if="ticket">
      <h4>{{ ticket.cliente }}</h4>
      <p class="ast-muted">{{ ticket.tipo }}{{ ticket.modelo ? ` · ${ticket.modelo}` : '' }}</p>
      <b-alert :show="!!error" variant="danger">
        {{ error }} <button v-if="conflict" class="btn btn-sm btn-outline-danger" :disabled="busy" @click="$emit('reload')">Recarregar chamado</button>
      </b-alert>
      <form class="ast-quick" @submit.prevent="$emit('patch', { ...quick, version: ticket.version })">
        <fieldset :disabled="busy">
          <div class="ast-grid">
            <label class="ast-field">Etapa do atendimento
              <select v-model="quick.status" class="form-control"><option v-for="s in statuses" :key="s.id" :value="s.id">{{ s.nome }}</option></select>
            </label>
            <label class="ast-field">Prioridade
              <select v-model="quick.prioridade" class="form-control"><option v-for="(label, key) in priorities" :key="key" :value="key">{{ label }}</option></select>
            </label>
            <label class="ast-field">Técnico responsável<input v-model="quick.tecnico" class="form-control" maxlength="60"></label>
            <div class="ast-actions"><button class="btn btn-primary" type="submit">{{ busy ? 'Salvando…' : 'Atualizar atendimento' }}</button></div>
          </div>
        </fieldset>
      </form>
      <dl class="ast-info">
        <dt>Telefone</dt><dd>{{ ticket.telefone || 'Não informado' }}</dd>
        <dt>Nº de série</dt><dd>{{ ticket.serie || 'Não informado' }}</dd>
        <dt>Defeito relatado</dt><dd class="ast-pre">{{ ticket.defeito }}</dd>
        <dt>Orçamento</dt><dd>{{ money(ticket.valor) }}</dd>
        <dt>Garantia</dt><dd>{{ ticket.garantia ? 'Sim' : 'Não' }}</dd>
        <dt>Entrada</dt><dd>{{ date(ticket.criadoEm) }}</dd>
        <template v-if="ticket.entregueEm"><dt>Entrega</dt><dd>{{ date(ticket.entregueEm) }}</dd></template>
        <dt>Tempo de atendimento</dt><dd>{{ days(ticket) }} dia(s)</dd>
      </dl>
      <h5>Histórico</h5>
      <form class="ast-note" @submit.prevent="$emit('note', note, () => { note = ''; })">
        <label class="ast-field">Nova anotação
          <textarea v-model="note" class="form-control" rows="2" maxlength="600" required :disabled="busy" placeholder="O que foi feito, testado ou combinado com o cliente" />
        </label>
        <button type="submit" class="btn btn-outline-primary" :disabled="busy || !note.trim()">Anotar</button>
      </form>
      <ol class="ast-history">
        <li v-for="h in history" :key="h.id"><time>{{ date(h.ts) }}</time><p class="ast-pre">{{ h.texto }}</p></li>
      </ol>
      <div class="ast-actions ast-between">
        <button class="btn btn-outline-danger" :disabled="busy" @click="$emit('delete')">Excluir chamado</button>
        <button class="btn btn-outline-primary" :disabled="busy" @click="$emit('edit')">Editar dados</button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { BModal, BAlert } from 'bootstrap-vue';
import { statuses, priorities, date, money, days } from './options';

export default {
  components: { BModal, BAlert },
  props: { visible: Boolean, ticket: { type: Object, default: null }, busy: Boolean, error: { type: String, default: '' }, conflict: Boolean },
  data: () => ({ statuses, priorities, note: '', quick: {} }),
  computed: { history() { return this.ticket ? [...(this.ticket.historico || [])].reverse() : []; } },
  watch: {
    ticket: { immediate: true, handler(t, old) {
      this.quick = t ? { status: t.status, prioridade: t.prioridade, tecnico: t.tecnico } : {};
      if (!old || !t || t.id !== old.id) this.note = '';
    } },
  },
  methods: { date, money, days },
};
</script>